import 'chart.js/auto';
import classNames from 'classnames';
import Delayed from 'components/containers/Delayed';
import dateFormat from 'dateformat';
import {
  UTILIZATION_RATE_GRAPH_CONFIG,
  UtilizationGraphPlugin,
} from 'pages/lend/components/LandaFinancingUtilizationRate/components/utils';
import {
  cashColor,
  loanColor,
} from 'pages/lend/components/LandaFinancingUtilizationRate/utils';
import React from 'react';
import { Line } from 'react-chartjs-2';
import { UtilizationType } from 'types/debt-types';
import classes from './index.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  data: UtilizationType[];
}

const UtilizationRateGraph = ({ data, className }: Props) => {
  const labels = data.map(({ date }) => dateFormat(new Date(date), 'mmm'));
  const cash = data.map(({ cashAmount }) => cashAmount);
  const loan = data.map(({ lentAmount }) => lentAmount);

  const innerData = {
    labels: labels,
    datasets: [
      {
        label: 'Mortgages',
        data: loan,
        borderWidth: 0,
        backgroundColor: loanColor,
        pointHoverRadius: 0,
        fill: true,
        pointRadius: 0,
      },
      {
        label: 'Cash',
        data: cash,
        borderWidth: 0,
        backgroundColor: cashColor,
        pointHoverRadius: 0,
        fill: true,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className={classNames(classes.container, className)}>
      <Delayed waitBeforeShow={200}>
        <Line
          className={classes.graph}
          options={{
            ...UTILIZATION_RATE_GRAPH_CONFIG,
            animation: false,
            responsive: true,
            interaction: {
              mode: 'index',
              intersect: false,
            },
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                padding: 10,
                enabled: true,
                usePointStyle: true,
                bodySpacing: 10,
                titleMarginBottom: 10,
                boxPadding: 10,
                callbacks: {
                  labelPointStyle: function () {
                    return {
                      pointStyle: 'circle',
                      rotation: 0,
                    };
                  },
                  label: function (context: any) {
                    return (
                      context.dataset.label +
                      ': $' +
                      context.parsed.y.toString().addCommaToNumbers()
                    );
                  },
                },
              },
            },
          }}
          data={innerData}
          plugins={[UtilizationGraphPlugin]}
        />
      </Delayed>
    </div>
  );
};

export default UtilizationRateGraph;
